import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { buildQueryParams, createQueryParam } from 'utils/helpers';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  SelfEnrollmentsListResponse,
  SelfEnrollmentsListQueryParam,
  SelfEnrollmentsPublicResponse,
} from 'pages/organization/self-enrollments/self-enrollments.interface';

@Injectable()
export class SelfEnrollmentsService {
  constructor(private http: HttpService) {}

  getSelfEnrollments(filters: SelfEnrollmentsListQueryParam): Observable<SelfEnrollmentsListResponse> {
    const queryParams = this.getQueryParams(filters);

    return this.http.get(`/self_enrollment${queryParams}`);
  }

  createSelfEnrollment(selfEnrollment) {
    return this.http.post('/self_enrollment', selfEnrollment);
  }

  getSelfEnrollmentDetails(uuid) {
    return this.http.get(`/self_enrollment/registration/${uuid}`);
  }

  getSelfEnrollmentAdminDetails(id) {
    return this.http.get(`/self_enrollment/${id}`).pipe(
      map(data => data.result),
      map(selfEnrollment => {
        return {
          ...selfEnrollment,
          certification: {
            ...selfEnrollment.certification,
            valid_from: selfEnrollment.certification.valid_from_date,
            valid_to: selfEnrollment.certification.valid_to_date,
          },
        };
      }),
    );
  }

  changeSelfEnrollmentStatus(uuid, status) {
    return this.http.put(`/self_enrollment/${uuid}`, status);
  }

  getEnrollmentStatus(link): Observable<SelfEnrollmentsPublicResponse> {
    const encodedLink = encodeURIComponent(link);
    return this.http.get(`/self_enrollment/is_enabled/${encodedLink}`);
  }

  private getQueryParams({
    limit,
    offset,
    orderId,
    orderType,
    search,
    filters,
  }: SelfEnrollmentsListQueryParam): string {
    return buildQueryParams(
      [
        limit && createQueryParam('limit', limit),
        offset && createQueryParam('offset', offset),
        orderId && createQueryParam('orderId', orderId),
        orderType && createQueryParam('orderType', orderType),
        search && createQueryParam('search', search),
        createQueryParam('filters', filters),
      ].filter(Boolean),
    );
  }
}
